import { makeObservable } from 'mobx';
import isUndefined from 'lodash/isUndefined';

import type { DrugHistoryData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';
import { DateHelper } from '@utils/DateHelper';

import { DrugHistory } from '@store/models/SystemFields/Drug/DrugHistory';

export interface DrugFilterParams {
    ids?: string[];
    isNotDeleted?: boolean;
    end?: Date;
    parentEntryId?: string;
}

export class DrugHistoryList extends List<DrugHistory, DrugHistoryData, DrugFilterParams> {
    constructor(drugs: DrugHistoryData[] = []) {
        super();
        makeObservable(this);

        this.filterParams = {
            end: new Date(),
            isNotDeleted: true,
        };

        this.set(drugs);
    }

    public update(id: string, updateParams: Partial<DrugHistoryData>) {
        const current = this.getExisting(id);

        super.update(id, { ...current, ...updateParams });
    }

    public serialize(): DrugHistoryData[] {
        const drugs: DrugHistoryData[] = [];

        this.list.forEach(drug => {
            drugs.push(drug.serialize());
        });

        return drugs;
    }

    protected create(params: DrugHistoryData): DrugHistory {
        return new DrugHistory(params);
    }

    protected filterValue(drug: DrugHistory, filterParams: DrugFilterParams): boolean {
        return (
            (!!drug.end && !!filterParams.end ? DateHelper.isBefore(filterParams.end, drug.end) : true) &&
            (!isUndefined(filterParams.ids) ? filterParams.ids.includes(drug.id) : true) &&
            (!isUndefined(filterParams.parentEntryId) ? filterParams.parentEntryId === drug.parentEntryId : true)
        );
    }
}
